import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
import buttonStyles from './styles'

const SaveButton = (props) => {
  // On click is for the few times we use this button outside of a form. Otherwise use onSubmit which should propigate automatically
  // because button is of type submit
  const { text, onClick, ...rest } = props

  return (
    <Button color='blue' type='submit' style={buttonStyles.bottomButtonStyle} onClick={onClick} {...rest}>
      {text}
      <Icon name='chevron right' />
    </Button>
  )
}

export default SaveButton
